export default function transformObjectToContextObject(inputObject) {
	const contextObject = {}
	Object.entries(inputObject).forEach(([name, section]) => {
		contextObject[name] = {}
		Object.entries(section).forEach(([key, value]) => {
			contextObject[name][key] = JSON.stringify(value)
		})
	})
	return contextObject
}
